import { useGetTicketsQuery } from "./ticketsApiSlice";
import Ticket from "./Ticket";
import useAuth from "../../hooks/useAuth";
import useTitle from "../../hooks/useTitle";
import PulseLoader from 'react-spinners/PulseLoader';

const TicketsList = () => {
    useTitle('Ticket-List');

    const { username, isProductManager, isSystemAnalyst } = useAuth();

    const {
        data: tickets,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetTicketsQuery('ticketsList', {
        pollingInterval: 15000,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let content;

    if (isLoading) content =
        <div className="container w-[60rem] h-[30rem] text-center mx-auto border-2">
            <PulseLoader color={"#FFF"} />
        </div>;

    if (isError) {
        content =
            <div className="container w-[60rem] h-[30rem] text-center mx-auto border-2">
                <p className="errmsg">{error?.data?.message}</p>
            </div>;
    }

    if (isSuccess) {
        const { ids, entities } = tickets;

        let filteredIds;
        if (isProductManager || isSystemAnalyst) {
            filteredIds = [...ids];
        } else {
            filteredIds = ids.filter(ticketId => entities[ticketId].username === username);
        }

        const tableContent = ids?.length && filteredIds.map(ticketId => <Ticket key={ticketId} ticketId={ticketId} />);

        content = (
            <>
                <div className="container w-[50rem] md:w-[80rem] h-[37rem] mx-auto border-2 rounded-lg border-gray-400">
                    <table className="container">
                        <thead>
                            <tr className="md:text-2xl text-[10px]">
                                <th className="border border-slate-600 px-2 py-2">Status</th>
                                <th className="border border-slate-600 px-2 md:px-6 py-2">Created</th>
                                <th className="border border-slate-600 px-2 md:px-6 py-2">Updated</th>
                                <th className="border border-slate-600 px-[2rem] md:px-[10rem] py-2">Service</th>
                                <th className="border border-slate-600 md:px-6 py-2">Assignee</th>
                                <th className="border border-slate-600 md:px-6 py-2">Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableContent}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }

    return content;
};

export default TicketsList;
